import { useContext } from "react";
import { useSelector } from "react-redux";
import { Boundaries } from "@planzone/core";
import { Identifiable, ProjectExpense } from "@planzone/dto";
import { CoreContext } from "../context";

interface ViewModel {
  isRequestSuccess: boolean;
  isRequestFailure: boolean;
  isRequestPending: boolean;
  projectExpenses: Identifiable<ProjectExpense>[];
  retrieveProjectExpenses(
    request: Boundaries["retrieveProjectExpenses"]["request"],
  ): void;
}

function useRetrieveProjectExpenses(): ViewModel {
  const { selector, core } = useContext(CoreContext);

  return {
    isRequestPending: useSelector(
      selector.isRetrieveProjectExpensesRequestPending,
    ),
    isRequestSuccess: useSelector(
      selector.isRetrieveProjectExpensesRequestSuccess,
    ),
    isRequestFailure: useSelector(
      selector.isRetrieveProjectExpensesRequestFailure,
    ),
    projectExpenses: useSelector(selector.getProjectExpenses),
    retrieveProjectExpenses: core.retrieveProjectExpenses,
  };
}

export { useRetrieveProjectExpenses };
